import styled from 'styled-components'
import ModelDropdown from './OptionDropdown/ModelDropdown'
import { COLORS } from 'consts/colors'

export const ModelSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 11px;
  gap: 12px;
`

export const ModelOptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 10px;

  .quality-dropdown,
  .option-dropdown,
  .duration-dropdown {
    height: 36px;
  }

  .quality-dropdown {
    flex-basis: 46%;
  }
  .duration-dropdown,
  .option-dropdown {
    width: auto;
    flex-grow: 1;
  }
`

export const VideoModelDropdown = styled(ModelDropdown)`
  height: 36px;
`

export const DropdownContainer = styled.div`
  min-width: 0;
  overflow: hidden;
`

export const DropdownLabel = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.secondary};
  margin-bottom: 11px;
`

export const ScopeCheckboxWrapper = styled.div`
  margin-bottom: 16px;
  .scope-checkbox-label {
    font-size: 14px;
    font-weight: 500;
  }

  .scope-checkbox-label p {
    font-size: inherit;
  }
`
